import React, { useState,useEffect } from "react";
import { addResult, deleteResult } from "../../api/api";
import { useGlobalData } from '../../context/GlobalDataContext';
import "./AdminPanel.css";

function ResultAdminPanel() {
  const { threeTable = {}, loading, fetchThreeTable } = useGlobalData();
  const jobs = threeTable.jobs || [];
  const results = threeTable.results || [];
  const [formData, setFormData] = useState({
    jobSlug: ""
  });
  const role = localStorage.getItem('role');


  useEffect(() => {
    if (!threeTable?.jobs?.length || !threeTable?.results?.length) {
      fetchThreeTable();
    }
  }, [threeTable?.jobs?.length, threeTable?.results?.length, fetchThreeTable]);

  // fetching handled by context

   if (role !== 'superadmin') {
    return <div style={{ color: 'red', textAlign: 'center', marginTop: '2rem' }}>Access denied: Superadmin only</div>;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    await addResult(formData);
    alert("Result added!");
    setFormData({ jobSlug: "" });
    await fetchThreeTable(); // Refresh results after addition
  };

  const handleDelete = async (id) => {
    if (window.confirm("Delete this result?")) {
      await deleteResult(id);
      alert("Result deleted!");
      await fetchThreeTable(); // Refresh results after deletion
    }
  };

  const getJobTitle = (jobSlug) => jobs.find((job) => job.slug === jobSlug)?.title || jobSlug;
  const filteredResults = results.filter((result) => !formData.jobSlug || result.jobSlug === formData.jobSlug);

  return (
    <div className="resource-admin-panel resource-admin-panel--red">
      <div className="resource-admin-panel__header">
        <div>
          <h2 className="resource-admin-panel__heading">Result Admin Panel</h2>
          <p className="resource-admin-panel__subtext">Yahan se result entries ko manage karo. Job choose karke result add karo, filtered list me dekhो aur live page ko open ya delete karo.</p>
        </div>
        <div className="resource-admin-panel__pill">Results</div>
      </div>

      <form className="resource-admin-panel__form" onSubmit={handleSubmit}>
        <div className="resource-admin-panel__field">
          <label className="resource-admin-panel__label">Select Job</label>
          <p className="resource-admin-panel__hint">Selected job ke slug ke against result record save hoga.</p>
          <select
            className="resource-admin-panel__select"
          value={formData.jobSlug}
          onChange={(e) => setFormData({ ...formData, jobSlug: e.target.value })}
        >
          <option value="">Select Job</option>
          {jobs.map((job) => (
            <option key={job._id} value={job.slug}>
              {job.title} ({job.slug})
            </option>
          ))}
        </select>
        </div>
        <button className="resource-admin-panel__submit" type="submit">Add Result</button>
      </form>

      <div className="resource-admin-panel__section">
        <div className="resource-admin-panel__section-top">
          <div>
            <h3 className="resource-admin-panel__section-title">Saved Results</h3>
            <p className="resource-admin-panel__section-meta">{filteredResults.length} items {formData.jobSlug ? `for ${formData.jobSlug}` : "across all jobs"}</p>
          </div>
        </div>

        {loading ? <p className="resource-admin-panel__empty">Loading...</p> : filteredResults.length === 0 ? (
          <p className="resource-admin-panel__empty">Abhi selected filter ke liye koi result entry nahi hai.</p>
        ) : (
          <div className="resource-admin-panel__list">
            {filteredResults.slice(0, 15).map((result) => {
              const isPending = result.status === "pending";
              const statusColor = isPending ? "#f7b500" : "#2ecc40";
              return (
                <div key={result._id} className="resource-admin-panel__item" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
                  <div>
                    <p className="resource-admin-panel__item-title">{getJobTitle(result.jobSlug)}</p>
                    <p className="resource-admin-panel__item-subtitle">Slug: {result.jobSlug}</p>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span style={{
                      background: statusColor,
                      color: '#fff',
                      borderRadius: 6,
                      padding: '2px 10px',
                      fontWeight: 600,
                      fontSize: 13
                    }}>{result.status === "pending" ? "Pending" : "Approved"}</span>
                    <a href={`/mform/${result.jobSlug}`} target="_blank" rel="noopener noreferrer" className="resource-admin-panel__link">
                      View Result
                    </a>
                    <button
                      type="button"
                      className="resource-admin-panel__delete"
                      onClick={() => handleDelete(result._id)}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default ResultAdminPanel;